function getPictureThumbnailUrl(picture) {
  return picture?.publicUrlThumbnail || picture?.publicUrlSmall || picture?.publicUrl || '';
}

function getPicturePreviewUrl(picture) {
  return picture?.publicUrlSmall || picture?.publicUrl || '';
}

function getPictureOriginalUrl(picture) {
  return picture?.originalDownloadUrl || picture?.publicUrl || '';
}

export { getPictureThumbnailUrl, getPicturePreviewUrl, getPictureOriginalUrl };
